<template>
<div class="chapter">
<div class="inner_page">
<p class="chapterTitle">Contents</p>
<p class="paraCenterTop"><a href="#/06_introduction">Introduction</a>, <a href="#/07_acknowledgement">Acknowledgments</a>, and <a href="#/08_abbreviation">Abbreviations</a></p>
<p class="paraCenterTop"><a href="#/09_ch01">The Washington Line (descendants of Lawrence Washington and John Washington, Jr.)</a></p>
<p class="paraCenterTop"><span href="#/20_bibliography" title="Link target outside of Sample">Bibliographical Abbreviations (The complete bibliography for Volume 6 is found at the end of Part 2)</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_contents.vue?5b953fe8